import React from "react";
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import {
  Card,
  CardHeader,
  Divider,
  CardActions,
  Typography,
  Avatar,
  CardContent,
  List,
  // Badge,
  ListItem,
  ListItemText,
  ListItemAvatar,
  IconButton,
  Tooltip,
  Button,
  ListItemSecondaryAction,
} from "@mui/material";
import withStyles from '@mui/styles/withStyles';
import HelpIcon from '../../../../../assets/Images/my_objectives_training.png';
// import CreateIcon from "@mui/icons-material/Create";
import AssignmentsIcon from '../../../../../assets/Images/grade_book_assignments.png';
import VisibilityIcon from '@mui/icons-material/Visibility';
// import NotificationsIcon from "@mui/icons-material/Notifications";
// import ScheduleIcon from "@mui/icons-material/Schedule";

const styles = theme => ({
  margin: {
    margin: theme.spacing(2)
  },
  extendedIcon: {
    marginRight: theme.spacing.unit
  },
  smallAvatar: {
    width: 30,
    height: 30,
    marginTop: 5,
  },
  card: {
    cursor: "pointer"
  },
  bigAvatar: {
    width: 40,
    height: 40,
    marginTop: 5,
    borderRadius: 0
  }
});
const VirtulaClasses = (props) => {
  const classes = props.classes;

  return (
    <Card>
      <CardHeader
        title={<Typography color="primary">Classes</Typography>}
        subheader={"Join your virtual classes"}
        onClick={() => window.open('#/dashboard/calendar')}
        avatar={<Avatar className={classes.bigAvatar} src={HelpIcon} />}
        className={classes.card}
      />
      <CardContent style={{ height: '210px' }}>
        <List style={{
          marginTop: '-30px'
        }}>
          {props.classesData.map((item, index) => {
            return (
              <ListItem key={index} style={{ paddingTop: 0 }} alignItems="flex-start">
                <ListItemAvatar>
                  <Avatar
                    alt="Remy Sharp"
                    src={AssignmentsIcon}
                    className={classes.smallAvatar}
                  />
                </ListItemAvatar>
                <ListItemText
                  primary={
                    <Typography
                      component="legend"
                      className={classes.inline}
                      color="textPrimary"
                    >
                      {item.courseLabel}
                    </Typography>
                  }
                  secondary={
                    <React.Fragment>
                      <Typography
                        variant="caption"

                        style={{ paddingLeft: "2px" }}
                      >
                        {item.startTimestamp}
                      </Typography>
                    </React.Fragment>
                  }
                />
                <ListItemSecondaryAction style={{ right: 0 }}>
                  <Button 
                    disabled={!item.meetingId} 
                    onClick={(e) => props.onJoinClick(e, item)} 
                    color="primary"
                  >
                    Join
                  </Button>
                </ListItemSecondaryAction>
              </ListItem>

            )
          })}

        </List>
      </CardContent>
      <Divider variant="middle" />
      <CardActions style={{ textAlign: "center" }} className={classes.actions}>
        <div>
          <Tooltip title="View All">
            <Link style={{ textDecoration: 'none' }} to="/dashboard/calendar" target="_blank">
              <IconButton aria-label="View" size="large">
                <VisibilityIcon />
              </IconButton>
            </Link>
          </Tooltip>
          {/* <Tooltip title="In Progress">
            <IconButton aria-label="In Progress">
              <Badge color="primary" badgeContent={4}>
                <NotificationsIcon />
              </Badge>
            </IconButton>
          </Tooltip>
          <Tooltip title="Action Awaited">
            <IconButton aria-label="Action Awaited">
              <Badge color="primary" badgeContent={4}>
                <ScheduleIcon />
              </Badge>
            </IconButton>
          </Tooltip> */}
        </div>
      </CardActions>
    </Card>
  );
}
VirtulaClasses.propTypes = {
  classes: PropTypes.object.isRequired,
  classesData: PropTypes.array,
  onJoinClick: PropTypes.func
}

VirtulaClasses.defaultProps = {
  classesData: [],
  onJoinClick: fn => fn
}

export default withStyles(styles)(VirtulaClasses);
